import { Block } from 'webiq.boilerplate'
import CheckoutParcelshopSelect from '../checkout-parcelshop-select'
import BlockFactory from 'webiq.boilerplate/scripts/support/BlockFactory'

export default class CheckoutParcelshop extends Block {
	static title = 'checkout-parcelshop'

	init() {
        this.zipcodeInput = this.getElement("zipcode")
        this.numberInput = this.getElement("number")
        this.parcelshopSelectContainer = this.getElement('select-container')
        this.parcelshopInfo = this.getElement('info')
        this.parcelshopInfoOverlay = this.getElement('info-overlay')

        this.zipcodeInput.addEventListener('sl-input', () => {
            this.numberInput.value = ""
        })

        this.zipcodeInput.addEventListener('sl-change', () => {
            if (this.numberInput.value != "") {
                this.getParcelshops(this.zipcodeInput.value, this.numberInput.value)
            }
        })

        this.numberInput.addEventListener('sl-change', () => {
            if (this.zipcodeInput.value != "") {
                this.getParcelshops(this.zipcodeInput.value, this.numberInput.value)
            }
        })

        window.eventEmitter.on("parcelshop:show", () => {
            this.element.classList.remove('tw-hidden')
            this.zipcodeInput.disabled = false
            this.numberInput.disabled = false
        })

        window.eventEmitter.on("parcelshop:hide", () => {
            this.element.classList.add('tw-hidden')
            this.zipcodeInput.disabled = true
            this.numberInput.disabled = true
        })

        window.eventEmitter.on('parcelshop:info', (data) => {
            const parcelshopName = this.getElement('name')
            parcelshopName.innerHTML = data.name + "<br>" + data.address.street + data.address.number + "<br>" + data.address.postalCode + data.address.city
            
            data.openingTimes.forEach((info) => {
                const element = this.element.querySelector('span[weekDay="' + info.weekDay + '"]')
                element.innerHTML = info.timeFrom.substr(0, 5) + " - " + info.timeTo.substr(0, 5)
            })

            this.parcelshopInfoOverlay.classList.add('tw-hidden')
            if (this.parcelshopInfo.classList.contains("tw-hidden")) {
                this.parcelshopInfo.classList.remove("tw-hidden")
            }

            window.eventEmitter.emit('parcelshop:done')
        })
	}

    getParcelshops(zipcode, number) {
        this.parcelshopInfo.classList.add("tw-hidden")
        window.eventEmitter.emit('parcelshop:loading')
        const payload = new FormData()
		payload.append('parcelshop_zipcode', zipcode)
		payload.append('parcelshop_number', number)
		payload.append('parcelshop_shipping_id', 10)

		fetch('/parcelshop', {
			method: 'POST',
			body: payload,
			credentials: 'same-origin',
		})
			.then((response) => response.json())
			.then((json) => {
                this.parcelshopSelectContainer.innerHTML = json.html
                
                this.bindSelectEvent()
                window.eventEmitter.emit('parcelshop:reload', {disabled: false})
			})
			.catch((error) => {
                console.log(error)
            })
    }

    bindSelectEvent() {
		this.element
			.querySelectorAll('.checkout-parcelshops-select')
			.forEach((element) => {
				BlockFactory.create(CheckoutParcelshopSelect, element, false)
			})
	}
}
